module.exports = __webpack_public_path__ + "files/d4820d0aae091be3456c71d08d803e9d.png";